import * as React from 'react';
import { TApiSubset } from '../../../../../api/endpoints/Subset';
import Tooltip from '../../../../Ui/Tooltip';
import { formatSubsetLabel } from '../../../../../utils/Format';

interface IProps {
  subset: TApiSubset;
  isAvailable: boolean;
  onClick: () => void;
}

/**
 * A button representing a subset.
 */
const SubsetButton = (props: IProps) => {
  const { subset, isAvailable, onClick } = props;

  const label = formatSubsetLabel(subset);

  return (
    <button className={`products__select-button ${!isAvailable && 'disabled'}`} onClick={onClick}>
      <span className="name">{label}</span>
      {
        subset.tooltip &&
        <Tooltip placement="left">
          <h3>{label}</h3>
          <p>{subset.tooltip}</p>
        </Tooltip>
      }
    </button>
  );
};

export default SubsetButton;
